import { Component, OnInit, Renderer2, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Globals } from '@foh/globals';
import { ActivatedRoute } from '@angular/router';
import { DepositpaymentService } from './depositpayment.service';
import * as alertFunctions from '@foh/shared/data/sweet-alerts';
import * as utils from '@foh/shared/services/utils';
import { NgForm, NgModel } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-deposit-payment',
    templateUrl: './deposit-payment.component.html',
    styleUrls: ['./deposit-payment.component.scss']
})
export class DepositPaymentComponent implements OnInit, AfterViewInit {

    reservation: any;
    imageSrc: string;
    record: any;
    billing: any;
    list: any;
    venue: any;
    token: any;
    orderId: any;
    routeObs$: any;
    totalPrice: any;
    loadingPaymentFrame = true;
    validAmountToPay = true;
    paymentIframeSrc: SafeResourceUrl;
    errorStatus = false;
    errorMessage: string;
    serviceFee: number = 25;
    isError = false;
    isLoading = false;
    isContentLoaded = false;
    @ViewChild('billingfname') billingFName: NgModel;
    @ViewChild('billinglname') billingLName: NgModel;
    @ViewChild('billingmobileno') billingMobileno: NgModel;
    @ViewChild('billingemail') billingEmail: NgModel;

    constructor(
        private activeRoute: ActivatedRoute,
        private depositpaymentService: DepositpaymentService,
        private cdr: ChangeDetectorRef,
        public sanitizer: DomSanitizer) {
        this.totalPrice = 0;
        this.billing = { first_name: "", last_name: "", email: "", phone_number: "", street: "", country: "", city: "" };
        this.reservation =
        {
            customer_profile: {}
        };
    }

    ngOnInit() {
        this.routeObs$ = this.activeRoute.params.subscribe(
            (params) => {
                this.token = params["token"];
                this.orderId = params["orderid"];
                if (this.token != "" && this.orderId != "" && typeof this.orderId !== "undefined") {
                    this.setupPaymentOrderRetrieve(params);
                }
                if (this.token != "" && (this.orderId == null || this.orderId == "" || typeof this.orderId === "undefined")) {
                    this.setupInitPayment(params);
                }
            }
        );
    }

    ngAfterViewInit() {
        if (this.isContentLoaded) {
            this.initPlugin();
        }
    }

    setupPaymentOrderRetrieve(params) {
        this.isLoading = true; // Show spinner
        this.depositpaymentService.retrieveOrderStatus(params).subscribe(
            (response: any) => {
                this.isLoading = false; // Hide spinner
                if (response.recordStatus) {
                    this.isError = false;
                    this.isContentLoaded = true; // Allow content to be displayed
                    this.reservation = response.reservation;

                    this.cdr.detectChanges(); // Trigger change detection
                    this.initPluginForPaymentConfirmation(); // Initialize stepper plugin
                } else {
                    this.isError = true;
                    this.errorMessage = response.recordMessage;
                }
            },
            () => {
                this.isLoading = false; // Hide spinner
                this.isError = true;
            }
        );
    }

    setupInitPayment(params) {
        this.isLoading = true; // Show spinner
        this.depositpaymentService.retrieveReservationInfo(params).subscribe(
            (response: any) => {
                this.isLoading = false; // Hide spinner
                if (response.error) {
                    this.isError = true;
                } else {
                    this.isError = false;
                    this.isContentLoaded = true; // Allow content to be displayed
                    this.reservation = response.reservation;
                    this.totalPrice = this.reservation.totalrequireddeposit - this.reservation.totalpaiddeposit;
                    this.venue = response.venue;
                    this.imageSrc = this.venue.logo;

                    this.cdr.detectChanges(); // Trigger change detection to ensure the view updates
                    this.initPlugin(); // Initialize stepper plugin after content is loaded
                }
            },
            () => {
                this.isLoading = false; // Hide spinner
                this.isError = true;
            }
        );
    }

    initPlugin() {
        (<any>$(".icons-tab-steps")).steps({
            headerTag: "h6",
            bodyTag: "fieldset",
            transitionEffect: "fade",
            titleTemplate: '<span class="step">#index#</span> #title#',
            enableContentCache: false,
            labels: {
                finish: 'Submit'
            },
            onFinished: (event, currentIndex) => {
                alert("Form submitted.");
            },
            onStepChanging: (event, currentIndex, newIndex) => {
                // Allways allow previous action even if the current form is not valid!
                if (currentIndex === 2) {
                    return false;
                }
                if (currentIndex > newIndex) {
                    return true;
                }
                if (newIndex === 1) {
                    return this.validateStep1(event, currentIndex, newIndex);
                }
                if (newIndex === 2) {
                    return this.validateStep2(event, currentIndex, newIndex);
                }

                return true;
            },
            onStepChanged: (event, currentIndex, priorIndex) => {
                if (currentIndex === 2) {
                    this.hideNextAndPrevButton();
                    this.getPaymentLink();
                }
            }
        });
    }

    initPluginForPaymentConfirmation() {
        (<any>$(".icons-tab-steps")).steps({
            headerTag: "h6",
            bodyTag: "fieldset",
            transitionEffect: "fade",
            titleTemplate: '<span class="step">#index#</span> #title#',
            enableContentCache: false,
            startIndex: 3,
            forceMoveForward: true,
            labels: {
                finish: 'Submit'
            },
        });

        this.hideNextAndPrevButton();
    }

    validateStep1(event, currentIndex, newIndex) {
        return true;
    }
    validateStep2(event, currentIndex, newIndex) {
        return this.billingFName.valid && this.billingLName.valid && this.billingMobileno.valid && this.billingEmail.valid;
    }

    hideNextAndPrevButton() {
        $(".actions ul li:nth-child(2)").hide();
        $(".actions ul li:nth-child(1)").hide();
    }

    getPaymentLink() {
        this.depositpaymentService.createPaymentLink({
            token: this.token,
            billing: this.billing
        }).subscribe((response: any) => {
            //this.paymentIframeSrc= this.sanitizer.bypassSecurityTrustResourceUrl(response);
            window.location.href = response;
            this.loadingPaymentFrame = false;
        });
    }

}
